import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Container from '~/explorer/components/container'

const Explorer = () => {
  return (
    <Router>
      <Switch>
        <Route path="/:org/:person/explorer*" children={<Container />} />
        <Route path="/explorer*" children={<Container />} />
      </Switch>
    </Router>
  )
}

export default Explorer
